import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [AsyncPipe, NgClass],
  template: `
    <div class="fixed right-4 top-4 z-[9999] flex flex-col gap-2">
      @for (toast of toastService.toasts | async; track toast.id) {
        <div
          class="flex min-w-[300px] items-center gap-3 rounded-lg border px-4 py-3 shadow-lg transition-all"
          [ngClass]="{
            'border-green-500 bg-green-950/90 text-green-100': toast.type === 'success',
            'border-red-500 bg-red-950/90 text-red-100': toast.type === 'error',
            'border-blue-500 bg-blue-950/90 text-blue-100': toast.type === 'info',
            'border-yellow-500 bg-yellow-950/90 text-yellow-100': toast.type === 'warning'
          }">
          <i class="material-symbols-outlined text-2xl">
            @if (toast.type === 'success') {
              check_circle
            } @else if (toast.type === 'error') {
              error
            } @else if (toast.type === 'warning') {
              warning
            } @else {
              info
            }
          </i>
          <span class="flex-1 text-sm font-medium">{{ toast.message }}</span>
          <button
            class="flex items-center justify-center rounded-full p-1 transition-colors hover:bg-white/10"
            (click)="toastService.remove(toast.id)">
            <i class="material-symbols-outlined text-base">close</i>
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);
}
